"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasRegisterOrAuthErrorSelector = hasRegisterOrAuthErrorSelector;
exports.isPhoneAuthValidateFormSubmitting = isPhoneAuthValidateFormSubmitting;
exports.registerOrAuthErrorSelector = registerOrAuthErrorSelector;
exports.resendTimeoutSelector = resendTimeoutSelector;
exports.sendValidationCodeStatusSelector = sendValidationCodeStatusSelector;
var _phoneAuth = require("../../../../types/phoneAuth");
var _requestStatus = require("../../../../types/requestStatus");
function isPhoneAuthValidateFormSubmitting(state) {
  return state.phoneAuth.registerOrAuth.status === _phoneAuth.ERegisterOrAuthStatus.Loading || state.phoneAuth.sendValidationCode.status === _requestStatus.ERequestStatus.Loading || state.phoneAuth.registerOrAuth.status === _phoneAuth.ERegisterOrAuthStatus.Succeed;
}
function resendTimeoutSelector(state) {
  return state.phoneAuth.sendValidationCode.secondsToRetry;
}
function sendValidationCodeStatusSelector(state) {
  return state.phoneAuth.sendValidationCode.status;
}
function hasRegisterOrAuthErrorSelector(state) {
  const {
    status,
    error
  } = state.phoneAuth.registerOrAuth;
  const {
    status: smsStatus,
    error: smsError
  } = state.phoneAuth.sendValidationCode;
  return status === _phoneAuth.ERegisterOrAuthStatus.Failed && error !== undefined || smsStatus === _requestStatus.ERequestStatus.Failed && smsError !== undefined;
}
function registerOrAuthErrorSelector(state) {
  return hasRegisterOrAuthErrorSelector(state) ? state.phoneAuth.registerOrAuth.error || state.phoneAuth.sendValidationCode.error : undefined;
}